// extracted by mini-css-extract-plugin
export default {"wrapperDrawer":"Drawer_wrapperDrawer__Kg6eH","content":"Drawer_content__7gEMP","closeArea":"Drawer_closeArea__Dv9by","FadeIn":"Drawer_FadeIn__seynP"};